import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import DataTable from "../DataTable/DataTable";
import { IoClose } from "react-icons/io5";

export default function MoreDetailsModal({
  open,
  handleClose,
  invoiceDetails,
}) {
  const columns = [
    { field: "invoice_id", headerName: "Invoice ID", width: 130 },
    { field: "service_id", headerName: "Service ID", width: 130 },
    { field: "service_name", headerName: "Service Name", width: 180 },
    {
      field: "service_description",
      headerName: "Service Description",
      width: 200,
    },
    { field: "location_id", headerName: "Location ID", width: 130 },
    { field: "charge_period", headerName: "Charge Period", width: 130 },
    { field: "charge_type", headerName: "Charge Type", width: 130 },
    { field: "amount", headerName: "Amount", width: 130 },
    {
      field: "discountPromotion",
      headerName: "Discount & Promotion",
      width: 180,
    },
    { field: "taxesSurcharges", headerName: "Taxes & Surcharges", width: 180 },
    { field: "total_usd", headerName: "Total (USD)", width: 130 },
    { field: "discrepancy", headerName: "Discrepancy", width: 130 },
  ];

  const rows = invoiceDetails?.map((invoice, index) => ({
    id: index,
    discrepancy: invoice?.discrepancy ||0,
    invoice_id: invoice?.invoice_id || "N/A",
    service_id: invoice?.service_id || "N/A",
    service_name: invoice?.service_name || "N/A",
    service_description: invoice?.service_description || "N/A",
    location_id: invoice?.location_id || "N/A",
    charge_period: invoice?.charge_period || "N/A",
    charge_type: invoice?.charge_type || "N/A",
    // amount: invoice?.amount || 'N/A',
    // discountPromotion: invoice?.['discount_&_promotion'] || 'N/A',
    // taxesSurcharges: invoice?.['taxes_&_surcharges'] || 'N/A',
    // total_usd: invoice?.total_usd || 'N/A'
    // amount: invoice?.amount
    //   ? Number(invoice.amount).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
    // discountPromotion: invoice?.["discount_&_promotion"]
    //   ? Number(invoice["discount_&_promotion"]).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
    // taxesSurcharges: invoice?.["taxes_&_surcharges"]
    //   ? Number(invoice["taxes_&_surcharges"]).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
    // total_usd: invoice?.total_usd
    //   ? Number(invoice.total_usd).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
      amount: invoice?.amount ? parseFloat(invoice.amount) : "N/A",
  discountPromotion: invoice?.["discount_&_promotion"]
    ? parseFloat(invoice["discount_&_promotion"])
    : "N/A",
  taxesSurcharges: invoice?.["taxes_&_surcharges"]
    ? parseFloat(invoice["taxes_&_surcharges"])
    : "N/A",
  total_usd: invoice?.total_usd ? parseFloat(invoice.total_usd) : "N/A",
  }));

  return (
    <div>
      <Modal
        open={open}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            handleClose(e);
          }
        }}
        style={{ zIndex: 99 }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "90%",
            maxWidth: "800px",
            borderRadius: 2,
            overflowY: "auto",
            zIndex: 99,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={{ fontSize: "24px" }}
            >
              Invoice Details
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <IoClose size={24} onClick={handleClose} />
            </div>
          </div>
          {/* Render the DataTable component instead of the regular HTML table */}
          <DataTable columns={columns} rows={rows} />
        </Box>
      </Modal>
    </div>
  );
}
